import React, { useState } from 'react';
import { Mic, Bed, MapPin } from 'lucide-react';
import { Button } from './ui/button';
import { toast } from './ui/sonner';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';

const FindCleanBedButton = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [showResults, setShowResults] = useState(false);
  const [nearestBeds, setNearestBeds] = useState([]);
  const [isListening, setIsListening] = useState(false);

  const findNearestCleanBed = () => {
    setIsListening(true);
    
    // Simulate voice recognition
    setTimeout(() => {
      const storedAssets = localStorage.getItem('e2-assets');
      if (storedAssets) {
        const assets = JSON.parse(storedAssets);
        
        // Find all clean beds (status: ready)
        const cleanBeds = assets.filter(a => a.type === 'bed' && a.status === 'ready');
        
        if (cleanBeds.length === 0) {
          toast.error(t('findCleanBed.noneAvailable'));
          setIsListening(false);
          return;
        }
        
        // Sort by floor and battery level (closest = lowest floor, highest battery)
        const sorted = cleanBeds.sort((a, b) => {
          if (a.floor !== b.floor) return a.floor - b.floor;
          return b.batteryLevel - a.batteryLevel;
        });
        
        setNearestBeds(sorted.slice(0, 3));
        setShowResults(true);
        setIsListening(false);
        toast.success(t('findCleanBed.found', { count: cleanBeds.length }));
      }
    }, 1500);
  };

  const handleNavigateTobed = (bed) => {
    setShowResults(false);
    navigate('/map', { 
      state: { 
        floor: bed.floor, 
        assetId: bed.id 
      } 
    });
  };

  return (
    <>
      <Button
        onClick={findNearestCleanBed}
        className="find-clean-bed-button"
        disabled={isListening}
      >
        <Mic size={18} className={isListening ? 'mic-listening' : ''} />
        {isListening ? t('findCleanBed.listening') : t('findCleanBed.button')}
      </Button>

      <Dialog open={showResults} onOpenChange={setShowResults}>
        <DialogContent className="clean-bed-results">
          <DialogHeader>
            <DialogTitle>
              <Bed size={24} className="inline mr-2" />
              {t('findCleanBed.title')}
            </DialogTitle>
            <DialogDescription>
              {t('findCleanBed.subtitle')}
            </DialogDescription>
          </DialogHeader>

          <div className="bed-results-list">
            {nearestBeds.map((bed, idx) => (
              <div 
                key={bed.id} 
                className="bed-result-item"
                onClick={() => handleNavigateTobed(bed)}
              >
                <div className="bed-rank">#{idx + 1}</div>
                <div className="bed-info">
                  <div className="bed-name">{bed.name}</div>
                  <div className="bed-location">
                    <MapPin size={14} />
                    Floor {bed.floor} - {bed.room}
                  </div>
                  <div className="bed-battery">
                    Batterie: {bed.batteryLevel}%
                  </div>
                </div>
                <Button size="sm" variant="outline">
                  {t('findCleanBed.viewOnMap')}
                </Button>
              </div>
            ))}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default FindCleanBedButton;
